import usePagebuilder from '../../../../../../hooks/pagebuilder/usePagebuilder';
import { ALL_COMPONENTS_INTERSECTION_TYPE, ColumnComponentInterface, UiComponent } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { ConditionalWrapper } from '../../../../../common/ConditionalWrapper';
import UIComponentElement from '../UIComponentElement';
import AddNestedComponent from './AddNestedComponent';
import NestedComponentControl from './NestedComponentControl';

interface NestedComponentInterface {
  component: ColumnComponentInterface;
  index: number;
  onMoveBack: () => void;
  onMoveForward: () => void;
  onEdit: (component: ALL_COMPONENTS_INTERSECTION_TYPE, index: number) => void;
  onDelete: (component: UiComponent) => void;
}

const NestedComponent = ({ component, index, onEdit, onMoveForward, onMoveBack, onDelete }: NestedComponentInterface) => {
  const pagebuilder = useSelector((state) => state.common.pagebuilder);
  const pagedata = useSelector((state) => state.common.pagedata);
  const templateEditMode = useSelector((state) => state.common.templateEditMode);

  const { isPagebuilderActive } = usePagebuilder();

  const getComponent = (id: string) => (isPagebuilderActive() ? pagebuilder.currentcolumncomponents : pagedata?.uicolumncomponents)?.find((c) => c._id === id)!;
  const nestedComponentId = component.components.find((c) => c.sortIndex === index)?.component;
  const nestedComponentIndex = component.components.find((c) => c.sortIndex === index)?.sortIndex;

  const currentComponent = nestedComponentId ? getComponent(nestedComponentId) : undefined;

  return currentComponent ? (
    <ConditionalWrapper
      condition={isPagebuilderActive()}
      wrapper={(children) => (
        <NestedComponentControl
          firstComponent={nestedComponentIndex === 0}
          lastComponent={nestedComponentIndex === 1}
          onDelete={() => onDelete(currentComponent)}
          onEdit={() => onEdit(currentComponent, index)}
          onMoveBack={onMoveBack}
          onMoveForward={onMoveForward}>
          {children}
        </NestedComponentControl>
      )}>
      <UIComponentElement uiComponent={currentComponent} />
    </ConditionalWrapper>
  ) : templateEditMode ? (
    <AddNestedComponent component={component} index={index} />
  ) : (
    <></>
  );
};
export default NestedComponent;
